import(/* webpackMode: "eager", webpackExports: ["PriceTable"] */ "/app/src/components/prices/PriceTable.tsx");
